module.exports = function getResource(label, vars = []) {
    let resources = {
        extraText: vars[0] ? ' All' : '',
        buttonText: vars[0] ? vars[1] ? `Unlove${vars[2]}` : `Loved${vars[2]}` : `Add${vars[2]} to Loves`
    };

    return resources[label];
};
